import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import type { AssetFamilyContributor } from '~/modules/artist-roster/lib/types';

interface ContributorLinkProps {
  contributor: AssetFamilyContributor;
  index?: number;
}

export function ContributorLink({ contributor, index }: ContributorLinkProps) {
  const { t } = useTranslation('grammar');

  return (
    <>
      {index ? t('commaSpace') : null}
      <Link to={`/roster/${contributor.partyId}`} className="hover:underline">
        {contributor.name}
      </Link>
    </>
  );
}

ContributorLink.displayName = 'ContributorLink';
